import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import ThankYou from "@/pages/ThankYou";

export const Route = createFileRoute("/thank-you")({
  component: ThankYou,
  head: () =>
    pageHead({
      title: "Payment Successful | jaik",
      description: "Thank you for your payment. Share a few project details and book your kickoff call.",
      path: "/thank-you",
      noindex: true,
    }),
});
